import { useEffect, useState } from "react";
import star from "../../asset/Sales/star.svg";
import dottedLine from "../../asset/Sales/DottedLine.svg";
const leftItems = [
  "Real-time meeting transcription",
  "AI-powered discovery notes",
  "Smart objection handling",
  "Conversation intelligence",
];

const rightItems = [
  "Automated meeting summaries",
  "Sales coaching recommendations",
  "Action item tracking",
  "Customer insight capture",
];

const poppins = { fontFamily: "'Poppins',sans-serif" };
const unbounded = { fontFamily: "'Unbounded',sans-serif" };

export default function Features() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const t = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(t);
  }, []);

  return (
    <section 
   id="features"
    className="w-full px-4 sm:px-6 md:px-10 lg:px-16  py-10 bg-white overflow-hidden">
      <style>{`
        .sa-fade-up{opacity:0;transform:translateY(24px);transition:opacity .8s ease,transform .8s ease}
        .sa-in{opacity:1!important;transform:translateY(0)!important}
        @keyframes sa-agent-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.04)}}
        .sa-agent-ring{animation:sa-agent-pulse 3s ease-in-out infinite}

       
      `}</style>

      {/* heading */}
      <div
        className={`max-w-3xl mx-auto text-center sa-fade-up ${mounted ? "sa-in" : ""}`}
      >
        <span
          className="inline-block font-prompt mb-3 px-4 py-1 rounded-md bg-[#FFE9E4] text-[#EB604A] font-semibold text-xs sm:text-sm"
         
        >
          Features
        </span>
        <h2
          className="mt-5 font-bold font-prompt text-[#3F3D3C] text-xl sm:text-3xl md:text-3xl lg:text-4xl leading-tight"
         
        >
        Live transcription, sales conversation intelligence, and real-time coaching <br/> — all in one AI sales agent.
        </h2>
        {/* <p
          className="mt-4 text-[#0C0200] font-jakarta text-[12px] lg:text-[15px]   leading-6  max-w-5xl mx-auto"
       
        >
          Sales representatives often spend valuable time taking notes, tracking
          objections, and remembering customer requirements. The Sales AI Agent
          works alongside your team during every meeting to capture critical
          information, identify opportunities, and recommend the best next
          actions.
        </p> */}
      </div>

      {/* ---- desktop / tablet: full radiating-lines diagram, pixel-exact, uniformly scaled ---- */}
      <div
        className={`hidden sm:block sa-fade-up ${mounted ? "sa-in" : ""}`}
        style={{ transitionDelay: "150ms" }}
      >
        <div
          className="
relative

mx-auto

mt-14

w-full

max-w-[1380px]
h-[560px]

lg:h-[400px]
md:h-[310px]
sm:h-[420px]
"
        >
          {/* connector lines */}

         <div className="absolute lg:left-[140px] md:left-[45px] lg:top-[40px] md:top-[30px] w-[70%] flex flex-col lg:gap-10 md:gap-6">
  {leftItems.map((item) => (
    <div key={item}>
      <img
        src={dottedLine}
        alt=""
        className="w-full lg:-mb-12 md:-mb-5"
      />

      <p
        className="mt-1 font-jakarta text-[18px] lg:text-[14px] md:text-[11px]
        font-semibold text-[#464342] "
        
      >
        {item}
      </p>
    </div>
  ))}
</div>

         <div className="absolute lg:right-[140px] md:right-[45px] lg:top-[40px] md:top-[30px] w-[70%] flex flex-col lg:gap-10 md:gap-6">
  {rightItems.map((item) => (
    <div key={item}>
      <img
        src={dottedLine}
        alt=""
        className="w-full scale-x-[-1] lg:-mb-12 md:-mb-5"
      />

      <p
        className="mt-1 font-jakarta text-right text-[18px]
        lg:text-[14px]
        md:text-[11px]
        font-semibold text-[#464342]"
        
      >
        {item}
      </p>
    </div>
  ))}
</div>

          {/* center circle */}
          <div
            className="
absolute

left-1/2

lg:top-[200px]
md:top-[160px]

-translate-x-1/2
shadow-lg
-translate-y-1/2

w-[240px]
h-[240px]


lg:w-[350px]
lg:h-[350px]

md:w-[230px]
md:h-[230px]





rounded-full

bg-[#FFDCD7]
"
          />

          <div
            className="
sa-agent-ring

absolute
shadow-md
left-1/2
top-1/2
lg:-mt-[140px]
lg:-ml-[140px]
md:-mt-[90px]
md:-ml-[95px]
-translate-x-1/2

-translate-y-1/2

w-[190px]
h-[190px]



lg:w-[280px]
lg:h-[280px]

md:w-[190px]
md:h-[190px]

sm:w-[130px]
sm:h-[130px]

rounded-full

bg-[#F7F6F4]

flex

items-center

justify-center
"
          >
            <div
              className="font-extrabold text-[#E8604A]  text-[34px]

lg:text-[45px]

md:text-[35px]

text-[18px] leading-10 font-prompt text-center"
              
            >
              Sales
              <br />
              Agent
            </div>
            <img
              src={star}
              alt=""
              width={35}
              height={35}
              className="
absolute

md:-top-5
lg:-top-8
md:left-40
lg:left-55

-translate-x-1/2


"
            />
          
          </div>
        </div>
      </div>

      {/* ---- mobile fallback: simplified stacked layout, nothing to break ---- */}
      <div
        className={`md:hidden mt-10 sa-fade-up ${mounted ? "sa-in" : ""}`}
        style={{ transitionDelay: "150ms" }}
      >
        <div className="relative mx-auto" style={{ width: 168, height: 168 }}>
          <div
            className="absolute inset-0 rounded-full"
            style={{ background: "#FCD6CC" }}
          />
          <div
            className="absolute rounded-full bg-[#F7F6F4] flex items-center justify-center"
            style={{ left: 14, top: 14, right: 14, bottom: 14 }}
          >
            <div
              className="font-extrabold text-[#EB604A] text-lg leading-6 text-center"
              style={unbounded}
            >
              Sales
              <br />
              Agent
            </div>
            <img
              src={star}
              alt=""
              width={20}
              height={20}
              className="absolute"
              style={{ left: "70%", top: -10, transform: "translateX(-65%)" }}
            />
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 xs:grid-cols-2 gap-3 max-w-md mx-auto">
          {[...leftItems, ...rightItems].map((label) => (
            <div
              key={label}
              className="flex items-center gap-2 rounded-lg border border-[#F3D9D2] bg-white px-3 py-2.5 text-xs font-semibold text-[#3F3D3C]"
              style={poppins}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[#EB604A] shrink-0" />
              {label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
